module.exports = __webpack_public_path__ + "img/big.ddd2fad1.jpg";